module.exports = __webpack_public_path__ + "img/top.f9f0ad3e.png";